export const calcHeight = (width: number) => (width * 9) / 16
export const calcWidth = (height: number) => (height * 16) / 9

export const getPercentage = (x: number, y: number) =>
    x && y ? (100 * x) / y : 0

export interface Dimensions {
    height: number
    width: number
    left?: number
    top?: number
    x?: number
    y?: number
}

export const aspectRatio = (dimensions: Dimensions) => {
    const {
        height: containerHeight,
        width: containerWidth,
        left: containerLeft = 0,
        top: containerTop = 0,
        x = 0,
        y = 0,
    } = dimensions
    const calculatedHeight = calcHeight(containerWidth)
    const calculatedWidth = calcWidth(containerHeight)
    const pillarbox = calculatedHeight > containerHeight
    const height = pillarbox ? containerHeight : calculatedHeight
    const width = pillarbox ? calculatedWidth : containerWidth
    const left = (containerLeft || x) + (containerWidth - width) / 2
    const top = (containerTop || y) + (containerHeight - height) / 2
    return { height, width, left, top }
}

export const getHeight = () => {
    if (typeof window === 'undefined' || typeof document === 'undefined') {
        return 0
    }
    const html = document.documentElement
    return Math.max(window.innerHeight, html?.clientHeight, html?.offsetHeight)
}

export const getWidth = () => {
    if (typeof window === 'undefined' || typeof document === 'undefined') {
        return 0
    }
    const html = document.documentElement
    return Math.max(window.innerWidth, html?.clientWidth, html?.offsetWidth)
}
